<div class="login-form">

  <mat-card>
    <mat-card-content>

      <mat-card-title>
        <h2>Login</h2>
      </mat-card-title>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput placeholder="email@example.com" formControlName="email" type="email" required>
          <mat-hint>Your account email</mat-hint>
          <mat-icon matSuffix>email</mat-icon>
          @if (email?.invalid && email?.touched) {
          <mat-error>{{getEmailErrorMessage()}}</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePass ? 'password' : 'text'" formControlName="password" required minlength="1">
          <button type="button" mat-icon-button matSuffix (click)="hidePass = !hidePass"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePass">
            <mat-icon>{{hidePass ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          @if (password?.invalid && password?.touched) {
          <mat-error>{{getPasswordErrorMessage()}}</mat-error>
          }
          <mat-hint>Your account password</mat-hint>
        </mat-form-field>

        <mat-card-actions>
          <button mat-raised-button color="accent" type="submit">Login</button>
        </mat-card-actions>

      </form>

      <p>
        New user?
        <a routerLink="/signup" routerLinkActive="active" ariaCurrentWhenActive="page">Sign up</a>
      </p>

    </mat-card-content>
  </mat-card>
</div>